import { useState } from 'react';
import { Button, StyledFlex } from '@tryhackme/thm-ui-components';
import { useParams } from 'react-router-dom';
import { WriteUpsTable } from 'src/features/room/components/write-ups-table';
import { Writeup } from 'src/features/room/components/writeup-modals/writeup-modal.types';
import { ShowWriteups } from 'src/features/room/components/writeup-modals';
import { RoomDetailsData } from 'src/features/room/room.types';
import { StyledActionWrapper } from './write-ups.styles';
export const WriteUps = ({
  roomDetails
}: {
  roomDetails?: RoomDetailsData;
}) => {
  const [openWriteupsModal, setOpenWriteupsModal] = useState<boolean>(false);
  const {
    roomCode
  } = useParams();
  const columnTitles: string[] = ['Write-up Title', 'Added By'];
  const writeUps: Writeup[] = roomDetails?.writeups ?? [];
  return <StyledFlex justifyContent="center" flexDirection="column" gap="3rem" data-testid="write-ups" data-sentry-element="StyledFlex" data-sentry-component="WriteUps" data-sentry-source-file="write-ups.tsx">
      {writeUps.length >= 1 && <WriteUpsTable writeupData={writeUps} columnHeaders={columnTitles} />}

      <StyledActionWrapper data-sentry-element="StyledActionWrapper" data-sentry-source-file="write-ups.tsx">
        <p>Teach, share knowledge and help other users by adding your own write-up.</p>{' '}
        <Button variant="outlined" color="secondary" onClick={() => setOpenWriteupsModal(true)} data-sentry-element="Button" data-sentry-source-file="write-ups.tsx">
          Add Write-up
        </Button>
        <ShowWriteups open={openWriteupsModal} onOpenChange={setOpenWriteupsModal} roomCode={roomDetails?.code ?? roomCode ?? ''} skipWriteupsList data-sentry-element="ShowWriteups" data-sentry-source-file="write-ups.tsx" />
      </StyledActionWrapper>
    </StyledFlex>;
};